// extracted by mini-css-extract-plugin
export default {"container":"RenderLoader_container__kVdb+","innerContainer":"RenderLoader_innerContainer__QhH++","loader":"RenderLoader_loader__C8OrB","load1":"RenderLoader_load1__62xdX"};